import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  rootReducerKey,
  SERVICE_PROJECT_OPERATION_REDUCER_TOKEN,
  serviceProjectOperationReducerProvider
} from './operation.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ServiceProjectOperationEffects } from './operation.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, SERVICE_PROJECT_OPERATION_REDUCER_TOKEN),
    EffectsModule.forFeature([ServiceProjectOperationEffects])
  ],
  providers: [
    serviceProjectOperationReducerProvider
  ]
})
export class ServiceProjectOperationStoreModule { }
